// @flow
import * as React from 'react';
import styles from './styles';

type Props = {
  onClick: Function,
  disabled?: boolean | null,
  title: string | React.Element<*>,
};

export default function ButtonLink({ disabled, onClick, title }: Props) {
  return (
    <button type="button" onClick={onClick} className="button-link" disabled={disabled}>
      <p> {title} </p>
      <style jsx>{styles}</style>
    </button>
  );
}

ButtonLink.defaultProps = {
  disabled: null,
};



// WEBPACK FOOTER //
// ./app/common/Buttons/ButtonLink/index.js